import m from 'mithril'
import {
    Setting,
} from 'app/models'

export default class FavoritePage {
    constructor() {
        this.models = []
        Setting.fetchFavoriteModels().then((_response) => {
            this.fa_models = _response.content
            this.models = _response.model
        })
    }
    view() {
        return [
            m(".px-2.py-4.position-relative.container",
                m(".row.w-100.m-0", [
                    m(".col-12.text-center.pb-3", [
                        m("span.font-weight-bold", {
                            style: {
                                fontSize: "1.75rem"
                            }
                        }, "我的最愛設定")
                    ]),
                    //新增我的最愛
                    m(".position-fixed", {
                        style: {
                            bottom: "30px",
                            right: "35px",
                            cursor: "pointer",
                            zIndex: 1024
                        },
                        onclick: (e) => {
                            e.preventDefault()
                        }
                    }, [
                        m("div.w-100.px-4.py-2", {
                            onclick: (e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                let model_id
                                Swal.fire({
                                    input: "text",
                                    inputLabel: "請輸入要增加的模板ID",
                                    inputPlaceholder: "請輸入數字",
                                    inputValue: model_id,
                                    confirmButtonText: "確認",
                                    showCancelButton: true,
                                    cancelButtonText: "取消",
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.fa_models.push(parseInt(result.value))
                                        Setting.saveFavoriteModels(this.fa_models).then(() => {
                                            Setting.fetchFavoriteModels().then((_response) => {
                                                this.models = _response.model
                                            })
                                        })

                                    }
                                });
                            },
                            style: {
                                color: "#FFFFFF",
                                borderRadius: "25px",
                                border: "1px solid #0f2027",
                                fontWeight: 500,
                                fontSize: "1.25rem",
                                background: "#0f2027",
                                background: "-webkit-linear-gradient(to right, #0f2027, #203a43, #2c5364)",
                                background: "linear-gradient(to right, #0f2027, #203a43, #2c5364)",

                            }
                        }, "+"),
                    ]),

                    m(".col-12.text-center", [
                        m(".row.w-100.m-0", [
                            this.models.map((_data) => {
                                return [
                                    m(".col-md-3.col-12.p-1", [
                                        m(".position-relative", {
                                            style: {
                                                borderRadius: "25px",
                                                border: (!_data.is_view) ? "2px solid #FBDFDF" : "2px solid #000000"
                                            },
                                        }, [
                                            m(".card-body", {
                                                style: {
                                                    borderRadius: "25px",
                                                    backgroundColor: "#FFFFFF"
                                                }
                                            }, [
                                                m("h5.card-title.pb-1", {
                                                    style: {
                                                        fontWeight: 700,
                                                        fontSize: (_data.name.length >= 12) ? "0.9rem" : "1.3rem"
                                                    }
                                                }, _data.id + "." + _data.name),
                                                m(".pb-3", [
                                                    m("span.px-2", {
                                                        style: {
                                                            bottom: "10px",
                                                            left: "10px",
                                                            fontWeight: 600,
                                                            fontSize: "0.9rem",
                                                            color: "#B6B6B6",
                                                            borderRadius: "25px",
                                                            border: "2px solid #B6B6B6",
                                                        },
                                                    },
                                                        "熱門度：" + _data.used_times.toLocaleString()
                                                    )
                                                ]),
                                                m(".py-1.d-inline.px-3", {
                                                    style: {
                                                        color: "#D53C3C",
                                                        borderRadius: "25px",
                                                        border: "2px solid #D53C3C",
                                                        fontWeight: 700,
                                                        fontSize: "1rem",
                                                        cursor: "pointer",
                                                    },
                                                    onclick: (e) => {
                                                        e.preventDefault()
                                                        e.stopPropagation()
                                                        Swal.fire({
                                                            title: "你確定要刪除此模板嗎？",
                                                            showCancelButton: true,
                                                            confirmButtonText: "確認",
                                                            cancelButtonText: "取消",
                                                        }).then((result) => {
                                                            if (result.isConfirmed) {
                                                                this.fa_models.splice(this.fa_models.indexOf(parseInt(_data.id)),1)
                                                                Setting.saveFavoriteModels(this.fa_models).then(() => {
                                                                    Setting.fetchFavoriteModels().then((_response) => {
                                                                        this.models = _response.model
                                                                    })
                                                                })
                                                                m.redraw()
                                                            }
                                                        });

                                                    }
                                                }, "移除我的最愛"),
                                            ]),
                                            m(".position-absolute", {
                                                style: {
                                                    top: "10px",
                                                    left: "20px",
                                                    fontSize: "1.25rem",
                                                    color: "#EAEAEA"
                                                }
                                            }, m(`i.fa.${_data.icon}`)),
                                            (!_data.is_view) ?
                                                m(".position-absolute", {
                                                    style: {
                                                        top: "10px",
                                                        right: "10px",
                                                        fontSize: "1.25rem",
                                                        color: "#BC1D1D"
                                                    }
                                                }, m("i.fa-regular.fa-eye-slash")) : "",
                                            (_data.is_free) ?
                                                m(".position-absolute", {
                                                    style: {
                                                        top: "10px",
                                                        right: "10px",
                                                        fontSize: "1.25rem",
                                                        boxShadow: "0 0 0 9px #FF0000",
                                                        background: "#FF0000",
                                                        clipPath: "inset(0-100%)",
                                                        inset: "0 0 auto auto",
                                                        transformOrigin: " 0 0",
                                                        transform: "translate(6.3%) rotate(30deg)",
                                                        color: "#FFFFFF"

                                                    }
                                                }, "Free") : ""
                                        ]),
                                    ]),
                                ]
                            }),
                        ])
                    ]),

                ])
            ),
        ]
    }
}